import { render, staticRenderFns } from "./ExtensionsCount.vue?vue&type=template&id=35397c07&scoped=true"
import script from "./ExtensionsCount.vue?vue&type=script&lang=js"
export * from "./ExtensionsCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35397c07",
  null
  
)

export default component.exports